import React, { useState ,useEffect} from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import {
  
  doctor,
  doctor01,
  imagesend,
  menuicon16,

} from "../imagepath";
import FeatherIcon from "feather-icons-react";
import { Link, useNavigate,useLocation } from "react-router-dom";


const HospitalProfile = () => {

  const[doctorData,setDoctorData]=useState();
  const location = useLocation();
  useEffect(() => { 
    const { doctor } = location.state || {}; // fallback in case state is missing
  console.log("doctor", doctor) 
  setDoctorData(doctor);
  }, []);
  

  const  id  = doctor?.id;
    const navigate = useNavigate();

  const [switches, setSwitches] = useState({
    vital: false,
    confusion: false,
    followUp: false,
    investigation: false,
    advice: false,
    diagnosis: false,
    medicalHistory: false,
    clinicalExamination: false,
    medicine: false,
    medicineWithContent: false
  });

  const handleToggle = (name) => {
    setSwitches(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  // Add this function to handle the save button click
const handleSave = () => {

  event.preventDefault(); // Prevent the default form submission behavior

  const formData = {
    vital: switches.vital,
    confusion: switches.confusion,
    followUp: switches.followUp,
    investigation: switches.investigation,
    advice: switches.advice,
    diagnosis: switches.diagnosis,
    medicalHistory: switches.medicalHistory,
    clinicalExamination: switches.clinicalExamination,
    medicine: switches.medicine,
    medicineWithContent: switches.medicineWithContent,
  };

  console.log("Form Data to be sent:", formData);

  // Example API call (replace with your actual API endpoint)
  fetch("https://your-api-endpoint.com/saveSettings", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(formData),
  })
    .then((response) => response.json())
    .then((data) => {
      console.log("Success:", data);
      
      alert("Settings saved successfully!");
    })
    .catch((error) => {
      console.error("Error:", error);
      alert("Failed to save settings.");
    });
};
  const [activeTab, setActiveTab] = useState("profile");

  
    return (
      <div>
        <>
          <Header />
          <Sidebar activeClassName="doctor" />
          <>
            <div className="page-wrapper">
              <div className="content">
                {/* Page Header */}
                <div className="page-header">
                  <div className="row">
                    <div className="col-sm-12">
                      <ul className="breadcrumb">
                        <li className="breadcrumb-item">
                          <Link to="/doctorlist">Doctor </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <i className="feather-chevron-right">
                            <FeatherIcon icon="chevron-right" />
                          </i>
                        </li>
                        <li className="breadcrumb-item active">
                          Doctor Profile
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                {/* /Page Header */}
                <div className="row">
                  <div className="col-sm-12">
                    <div className="row">
                      <div className="col-lg-4">
                        <div className="doctor-personals-grp">
                          <div className="card">
                            <div className="card-body">
                              
                              <div className="about-me-list">
                                <ul className="list-space">
                                  <li>
                                    <h4>Doctor Name</h4>
                                    <span>{doctorData?.Name} {doctorData?.lastname}</span>
                                  </li>
                                  <li>
                                    <h4>Mobile no.</h4>
                                    <span>{doctorData?.mobile}</span>
                                  </li>
                                  <li>
                                    <h4>Email</h4>
                                    <span>{doctorData?.Email}</span>
                                  </li>
                                  <li>
                                    <h4>Status</h4>
                                    <span>Active</span>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-8">
                        <div className="doctor-personals-grp">
                          <div className="card">
                            <div className="card-body">
                              <div className="tab-content-set">
                                <ul className="nav">
                                  <li>
                                    <Link
                                      to="#"
                                      className={
                                        activeTab === "profile" ? "active" : ""
                                      }
                                      onClick={() => setActiveTab("profile")}
                                    >
                                      <span className="set-about-icon me-2">
                                        <img src={doctor} alt="" />
                                      </span>
                                      About me
                                    </Link>
                                  </li>
                                  <li>
                                    <Link
                                      to="#"
                                      className={
                                        activeTab === "setting" ? "active" : ""
                                      }
                                      onClick={() => setActiveTab("setting")}
                                    >
                                      <span className="set-about-icon me-2">
                                        <img src={menuicon16} alt="" />
                                      </span>
                                      Settings
                                    </Link>
                                  </li>
                                </ul>
                              </div>
                              <div
                                id="profile"
                                style={{
                                  display:
                                    activeTab === "profile" ? "block" : "none",
                                }}
                              >
                                <div className="personal-list-out">
                                  <div className="row">
                                    <div className="col-12">
                                      <div className="form-heading">
                                        <h4>BASIC DETAILS</h4>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Full Name</h2>
                                        <h3 className="pb-3">{doctorData?.Name} {doctorData?.lastname}</h3>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Mobile </h2>
                                        <h3>{doctorData?.mobile}</h3>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Email</h2>
                                        <h3>{doctorData?.Email}</h3>
                                      </div>
                                    </div>
                                    <div className="col-xl-3 col-md-6">
                                      <div className="detail-personal">
                                        <h2>Location</h2>
                                        <h3>{doctorData?.address}</h3>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                {/* <div className="hello-park">
                                  <p>
                                    Completed my graduation in Gynaecologist
                                    Medicine from the well known and renowned
                                    institution of India – SARDAR PATEL MEDICAL
                                    COLLEGE, BARODA in 2000-01, which was
                                    affiliated to M.S. University. I ranker in
                                    University exams from the same university
                                    from 1996-01.
                                  </p>
                                  <p>
                                    Worked as Professor and Head of the
                                    department ; Community medicine Department
                                    at Sterline Hospital, Rajkot, Gujarat from
                                    2003-2015
                                  </p>
                                </div> */}
                              </div>
                              <div
                                id="setting"
                                style={{
                                  display:
                                    activeTab === "setting" ? "block" : "none",
                                }}
                              >
                                <div className="setting-form-blk">
                                  <form>
                                    <div className="row">
                                      <div className="col-12">
                                        <div className="form-heading">
                                          <h4>PRINT RX SETTING</h4>
                                        </div>
                                      </div>
                                      {/* Left Column */}
                                      <div className="col-12 col-md-3 col-xl-6 ">
                                        <div className="form-group">
                                          <span>
                                            <label className="form-label">
                                              Vital
                                            </label>

                                            <div className="form-check form-switch">
                                              <input
                                                className="form-check-input"
                                                type="checkbox"
                                                checked={switches.vital}
                                                onChange={() =>
                                                  handleToggle("vital")
                                                }
                                              />
                                            </div>
                                          </span>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Confusion
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={switches.confusion}
                                              onChange={() =>
                                                handleToggle("confusion")
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Follow Up
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={switches.followUp}
                                              onChange={() =>
                                                handleToggle("followUp")
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Investigation
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={switches.investigation}
                                              onChange={() =>
                                                handleToggle("investigation")
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Advice
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={switches.advice}
                                              onChange={() =>
                                                handleToggle("advice")
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>

                                      {/* Right Column */}
                                      <div className="col-12 col-md-6 col-xl-6">
                                        <div className="form-group">
                                          <label className="form-label">
                                            Diagnosis
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={switches.diagnosis}
                                              onChange={() =>
                                                handleToggle("diagnosis")
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Medical History
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={switches.medicalHistory}
                                              onChange={() =>
                                                handleToggle("medicalHistory")
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Clinical Examination
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={
                                                switches.clinicalExamination
                                              }
                                              onChange={() =>
                                                handleToggle(
                                                  "clinicalExamination"
                                                )
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Medicine
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={switches.medicine}
                                              onChange={() =>
                                                handleToggle("medicine")
                                              }
                                            />
                                          </div>
                                        </div>

                                        <div className="form-group">
                                          <label className="form-label">
                                            Medicine with content
                                          </label>
                                          <div className="form-check form-switch">
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              checked={
                                                switches.medicineWithContent
                                              }
                                              onChange={() =>
                                                handleToggle(
                                                  "medicineWithContent"
                                                )
                                              }
                                            />
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    <div className="col-12">
                                      <div className="doctor-submit">
                                        <button
                                          type="submit"
                                          className="btn btn-primary submit-form me-2"
                                          onClick={handleSave}
                                        >
                                          Save
                                        </button>
                                        <button
                                          type="submit"
                                          className="btn btn-primary cancel-form me-2 text-center"
                                        >
                                          Cancel
                                        </button>
                                      </div>
                                    </div>
                                  </form>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="notification-box">
                <div className="msg-sidebar notifications msg-noti">
                  <div className="topnav-dropdown-header">
                    <span>Messages</span>
                  </div>
                  <div className="drop-scroll msg-list-scroll" id="msg_list">
                    <ul className="list-box">
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">R</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                Richard Miles{" "}
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item new-message">
                            <div className="list-left">
                              <span className="avatar">J</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">John Doe</span>
                              <span className="message-time">1 Aug</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">T</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                {" "}
                                Tarah Shropshire{" "}
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">M</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                Mike Litorus
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">C</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                {" "}
                                Catherine Manseau{" "}
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">D</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                {" "}
                                Domenic Houston{" "}
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">B</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                {" "}
                                Buster Wigton{" "}
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">R</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                {" "}
                                Rolland Webber{" "}
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">C</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                {" "}
                                Claire Mapes{" "}
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">M</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                Melita Faucher
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">J</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                Jeffery Lalor
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">L</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                Loren Gatlin
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                      <li>
                        <Link to="chat.html">
                          <div className="list-item">
                            <div className="list-left">
                              <span className="avatar">T</span>
                            </div>
                            <div className="list-body">
                              <span className="message-author">
                                Tarah Shropshire
                              </span>
                              <span className="message-time">12:28 AM</span>
                              <div className="clearfix" />
                              <span className="message-content">
                                Lorem ipsum dolor sit amet, consectetur
                                adipiscing
                              </span>
                            </div>
                          </div>
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="topnav-dropdown-footer">
                    <Link to="chat.html">See all messages</Link>
                  </div>
                </div>
              </div>
            </div>
            <div
              id="delete_patient"
              className="modal fade delete-modal"
              role="dialog"
            >
              <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                  <div className="modal-body text-center">
                    <img src={imagesend} alt="" width={50} height={46} />
                    <h3>Are you sure want to delete this ?</h3>
                    <div className="m-t-20">
                      {" "}
                      <Link
                        to="#"
                        className="btn btn-white me-2"
                        data-bs-dismiss="modal"
                      >
                        Close
                      </Link>
                      <button type="submit" className="btn btn-danger">
                        Delete
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        </>
      </div>
    );
}

export default HospitalProfile
